// src/components/common/MerchantBadge.js
// Badge de graduation du marchand (selon le pack d'abonnement)
// Maxula

import React from 'react';
import { FiAward } from 'react-icons/fi';

const TIERS = {
  bronze: { label: 'Bronze', bg: '#f5e7da', fg: '#9a5b2e', ring: '#cd7f32' },
  silver: { label: 'Argent', bg: '#eef1f4', fg: '#5b6573', ring: '#9aa5b1' },
  gold: { label: 'Or', bg: '#fdf3d6', fg: '#8a6d1a', ring: '#d4af37' },
  platinum: { label: 'Platine', bg: '#eaf2f5', fg: '#2b5563', ring: '#5fa8c4' }
};

const MerchantBadge = ({ tier, size = 'sm', className = '' }) => {
  if (!tier || tier === 'none' || !TIERS[tier]) return null;
  const t = TIERS[tier];
  const pad = size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${pad} ${className}`}
      style={{ background: t.bg, color: t.fg, boxShadow: `inset 0 0 0 1px ${t.ring}` }}
      title={`Marchand ${t.label}`}
    >
      <FiAward size={size === 'lg' ? 16 : 12} />
      {t.label}
    </span>
  );
};

export default MerchantBadge;
